import { GuaranteesApplicationStatus } from '~/store/guarantees/types.ts';

export const USAPOK_APPROVAL_TEXT = {
  content: 'Перевірте відповідність із Б2',
  accessDeniedText: 'У вас немає доступу до кроку перевірки відповідності із Б2.',
  confirmButton: 'Підтвердити',
  submitSuccessMessage: 'Заявку передано до еАрхіву',
  successCloseButton: 'Закрити',
} as const;

export const USAPOK_APPROVAL_GET_STARTED_PATH = '/guarantees/administrator/get-started';
export const USAPOK_APPROVAL_TASKS_PATH = '/tasks';

export const usapokApprovalEditableStatuses = new Set<GuaranteesApplicationStatus>([
  GuaranteesApplicationStatus.AWAITING_USAPOK_APPROVAL,
  GuaranteesApplicationStatus.IN_PROGRESS_USAPOK_APPROVAL,
]);
